import { Component, inject, OnInit, signal } from '@angular/core';
import { BadgeComponent } from '../shared/badge/badge.component';
import { MatTab, MatTabGroup, MatTabLabel } from '@angular/material/tabs';
import { FriendsListComponent } from './friends-list/friends-list.component';
import { PageComponent } from '../shared/page/page.component';
import { FriendsService } from './service/friends.service';
import { MyContactsListComponent } from "./my-contacts-list/my-contacts-list.component";
import { RequestsListComponent } from "./requests-list/requests-list.component";
import { HeaderLayoutComponent } from "../header-layout/header-layout.component";

@Component({
  selector: 'app-friends',
  standalone: true,
  imports: [
    BadgeComponent,
    MatTab,
    MatTabGroup,
    MatTabLabel,
    FriendsListComponent,
    PageComponent,
    RequestsListComponent,
    MyContactsListComponent,
    HeaderLayoutComponent,
  ],
  templateUrl: './friends.component.html',
  styleUrl: './friends.component.scss',
})
export class FriendsComponent implements OnInit {
  friendsService = inject(FriendsService);
  requestTotal = this.friendsService.requestTotal;
  public tabUpdated = signal<number>(0);

  onTabIndexChange(index: number) {
    this.tabUpdated.set(index);
  }

  ngOnInit() {
    this.friendsService.getRequests().subscribe((res) => {
      if (res.total) {
        this.friendsService.setRequestTotal(res.total);
      }
    });
  }
}
